import { MENU_CODE } from '~/constants/menu'
import { useTextUtils } from '~/composables/utils/useTextUtils'

export const useAboutUsPage = async () => {
  const nuxtApp = useNuxtApp()
  const body = ref<AboutUs | undefined | null>()
  const previewStore = usePreviewStore()
  const { t } = useI18n()

  const statusStore = useStatusStore()

  const { getPageInfo, getBreadcrumb, domain, getPath } = useNavigationMenu()
  const pageInfo = getPageInfo(MENU_CODE.ABOUT_US)
  const section = reactive<Section>({ title: '', description: '' })
  section.title = pageInfo?.topic || pageInfo?.title || ''
  section.description = pageInfo?.description || ''

  const breadcrumbItem = ref<BreadCrumb[]>([])
  breadcrumbItem.value = getBreadcrumb()

  const pageTitle = computed(() =>
    pageInfo?.metaTitle ||
    body.value?.title ||
    body.value?.metaTitleFront ||
    t('global.loading'),
  )

  useCustomSeo({
    title: () => pageInfo?.metaTitleFront,
    description: () => pageInfo?.metaDescriptionFront || pageInfo?.description,
    image: () => pageInfo?.ogImage?.large,
  })

  onMounted(() => {
    statusStore.updatePreloading(false)
  })

  if (previewStore.isPreview) {
    const { data: aboutUs } = await useAboutUsPreviewApi()
    body.value = aboutUs.value
  } else {
    const { data: aboutUs } = await useAboutUsApi()
    body.value = aboutUs.value
  }

  // Add schema.org data
  const { currentLocaleCode } = useLanguage()
  const { stripHtml } = useTextUtils()

  nuxtApp.runWithContext(() => useSchemaOrg([
    defineWebPage({
      '@type': 'WebPage',
      '@id': `${domain.value}${getPath({ componentName: 'AboutUs' })}#webpage`,
      name: pageInfo?.metaTitleFront,
      url: `${domain.value}${getPath({ componentName: 'AboutUs' })}`,
      description: stripHtml(body.value?.content || ''),
      inLanguage: currentLocaleCode.value,
      about: {
        '@id': `${domain.value}/#organization`,
      },
      primaryImageOfPage: {
        '@id': `${domain.value}/#logo`,
      },
      isPartOf: {
        '@id': `${domain.value}/#website`,
      },
    }),
  ]))

  return {
    body,
    pageTitle,
    section,
    breadcrumbItem,
  }
}
